import React from 'react'

function TnC() {
  return (
    <div>TnC</div>
  )
}

export default TnC